import config from "../config"
const baseUrl = config.base_url + "z_farm_work_lib_prescription/"
export default {
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    update: {
        url: baseUrl + "update",
        type: "post",
    },
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    getByLibCode: {
        url: baseUrl + "getByLibCode",
        type: "get",
    },
    testJson: {
        url: baseUrl + "testJson",
        type: "get",
    }
} 